import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensFreeServicesSummaries} from './citizens-free-services-summaries.model';
import * as CitizensFreeServicesSummariesActions from './citizens-free-services-summaries.actions';

export const citizensFreeServicesSummariesesFeatureKey = 'citizensFreeServicesSummarieses';

export interface State extends EntityState<CitizensFreeServicesSummaries> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensFreeServicesSummaries> = createEntityAdapter<CitizensFreeServicesSummaries>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensFreeServicesSummariesActions.addCitizensFreeServicesSummaries,
    (state, action) => adapter.addOne(action.citizensFreeServicesSummaries, state)
  ),
  on(CitizensFreeServicesSummariesActions.upsertCitizensFreeServicesSummaries,
    (state, action) => adapter.upsertOne(action.citizensFreeServicesSummaries, state)
  ),
  on(CitizensFreeServicesSummariesActions.addCitizensFreeServicesSummariess,
    (state, action) => adapter.addMany(action.citizensFreeServicesSummariess, state)
  ),
  on(CitizensFreeServicesSummariesActions.upsertCitizensFreeServicesSummariess,
    (state, action) => adapter.upsertMany(action.citizensFreeServicesSummariess, state)
  ),
  on(CitizensFreeServicesSummariesActions.updateCitizensFreeServicesSummaries,
    (state, action) => adapter.updateOne(action.citizensFreeServicesSummaries, state)
  ),
  on(CitizensFreeServicesSummariesActions.updateCitizensFreeServicesSummariess,
    (state, action) => adapter.updateMany(action.citizensFreeServicesSummariess, state)
  ),
  on(CitizensFreeServicesSummariesActions.deleteCitizensFreeServicesSummaries,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensFreeServicesSummariesActions.deleteCitizensFreeServicesSummariess,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensFreeServicesSummariesActions.loadCitizensFreeServicesSummariess,
    (state, action) => adapter.setAll(action.citizensFreeServicesSummariess, state)
  ),
  on(CitizensFreeServicesSummariesActions.clearCitizensFreeServicesSummariess,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
